// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qk-0";